import { supabase } from '@/lib/supabase/client'
import { Tables } from '@/lib/supabase/types'

export type PriceWithProduct = Tables<'prices'> & {
  products: Tables<'products'> | null
}

const MAIN_PRICE_ID =
  import.meta.env.VITE_STRIPE_PRICE_ID || 'price_1STsrs2LhAk4LmDDceXXVlhP'

export const getMainPrice = async (): Promise<PriceWithProduct | null> => {
  const { data, error } = await supabase
    .from('prices')
    .select('*, products(*)')
    .eq('id', MAIN_PRICE_ID)
    .eq('active', true)
    .single()

  if (error && error.code !== 'PGRST116') {
    console.error('Error fetching main price:', error)
    throw error
  }

  return data
}
